import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import { ContentBodyContext } from '../MainContent';
import jwt from 'jwt-decode'
import swal from 'sweetalert'

function WhatsappReadOnly() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const token = jwt(localStorage.getItem('token-helpdesk-umy'))

    const [state, setstate] = useState({ init: true, status: stateContentBody.whatsappAuth.status, img: '' })

    useEffect(() => {
        if (state.init) {
            stateContentBody.socket.emit('create-session', {
                id: token.work_unit_id,
                description: `Assign by ${token.user}`
            })
        }
    }, [state.init])

    useEffect(() => {
        stateContentBody.socket.on(`ready-${token.work_unit_id}`, function (data) {
            if (data.message.status == "error") {
                swal("Error!", `${data.message.message}`, "error", {
                    button: "OK",
                });
            }

            dispatchContentBody({
                type: "WA_STATUS",
                status: true,
                trigger: null
            })

        })

        stateContentBody.socket.on(`whatsapp-restart-callback-${token.work_unit_id}`, function (data) {
            dispatchContentBody({
                type: "WA_STATUS",
                status: null,
                trigger: null
            })

            swal("Info!", `${data.message}`, "info", {
                button: "OK",
            });
        })
    }, [])

    useEffect(() => {
        setstate({
            ...state,
            status: stateContentBody.whatsappContact == null ? 'Not Found' : stateContentBody.whatsappAuth.status == null ? 'Restarting' : stateContentBody.whatsappAuth.status == true ? 'Connected' : 'Disconnected',
            img: stateContentBody.whatsappAuth.status == null ? './assets/img/loading.gif' : stateContentBody.whatsappAuth.status ? './assets/img/whatsapp-icon.png' : './assets/img/whatsapp-icon-red.png'
        })
    }, [stateContentBody.whatsappContact, stateContentBody.whatsappAuth])

    return (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" >
            <div className="card card-statistic-1">
                <div className="card-icon pl-2">
                    <div className="gallery gallery-md">
                        <img className="gallery-item" src={state.img} data-title="whatsapp-status"></img>
                    </div>
                </div>
                <div className="card-wrap">
                    <div className="card-header">
                        <h4>Whatsapp Status</h4>
                    </div>
                    <div className="card-body">
                        {state.status}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatsappReadOnly
